import { apiClient } from '@/lib/apiClient';
import type {
  RequisicaoCompraResumo,
  RequisicaoCompraDetalhe,
  CriarRequisicaoCompraRequest,
  AtualizarRequisicaoCompraRequest,
  AprovarRequisicaoCompraRequest,
  StatusRequisicaoCompra,
  FiltrosListaCompras,
  PaginadoComResumo,
} from '../types';
import { paramsListaCompras } from '../types';

const BASE = '/api/compras/requisicoes';

export const requisicaoCompraService = {
  /** Lista paginada; status, busca, período de emissão e ordenação são feitos no servidor. */
  async getAll(
    pagina = 1, tamanhoPagina = 20, status?: StatusRequisicaoCompra, filtros: FiltrosListaCompras = {},
  ): Promise<PaginadoComResumo<RequisicaoCompraResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<RequisicaoCompraResumo>>(BASE, {
      params: { pagina, tamanhoPagina, status, ...paramsListaCompras(filtros) },
    });
    return data;
  },

  async getById(id: number): Promise<RequisicaoCompraDetalhe> {
    const { data } = await apiClient.get<RequisicaoCompraDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarRequisicaoCompraRequest): Promise<RequisicaoCompraDetalhe> {
    const { data } = await apiClient.post<RequisicaoCompraDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarRequisicaoCompraRequest): Promise<RequisicaoCompraDetalhe> {
    const { data } = await apiClient.put<RequisicaoCompraDetalhe>(`${BASE}/${id}`, request);
    return data;
  },

  async enviar(id: number): Promise<RequisicaoCompraResumo> {
    const { data } = await apiClient.post<RequisicaoCompraResumo>(`${BASE}/${id}/enviar`);
    return data;
  },

  async aprovar(id: number, request: AprovarRequisicaoCompraRequest): Promise<RequisicaoCompraResumo> {
    const { data } = await apiClient.post<RequisicaoCompraResumo>(`${BASE}/${id}/aprovar`, request);
    return data;
  },

  async cancelar(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
